import { PaymentIntent } from '@stripe/stripe-js'
import { baseApi } from './base'
import { Consultation } from '../models/consultation.model'

export const chargeApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    confirmPayment: builder.mutation<Consultation, string>({
      query: (consultationId) => `/charge/${consultationId}/confirmation`,
    }),
    setPrice: builder.mutation<void, { consultationId: string; price: number }>({
      query: ({ consultationId, price }) => ({
        url: `/charge/${consultationId}/price`,
        method: 'POST',
        body: { price },
      }),
    }),
    startPaymentByReceiverID: builder.mutation<PaymentIntent, { consultationId: string; receiverID: string }>({
      query: ({ consultationId, receiverID }) => ({
        url: `/charge/${consultationId}/pay/other`,
        method: 'POST',
        body: { receiverID },
      }),
    }),
  }),
})
